import React, { useCallback, useState } from 'react';
import SelectSevenSection from '../Step2/SelectGoals/SelectSevenSection';
import MarketingOolaWheel from './MarketingOolaWheel';
import MarketingHeader from './MarketingHeader';
import CStepper from '../Common/Header/CStepper';
import { buildDemoStep2State } from './marketingStepDemoData';
import '../Steps.css';
import '../Step2/SelectGoalsStep2.css';
import '../Step2/SelectGoals/OolaSevenSection.css';
import './MarketingAssets.css';

/** V1 Step 2 Pick 7 — production Wheel + production goal list. */
const MarketingStep2Preview = () => {
    const [, forceRender] = useState(0);
    const forceUpdate = useCallback(() => {
        forceRender((n) => n + 1);
    }, []);

    const [allState, setAllState] = useState(() => buildDemoStep2State());

    const changeData = useCallback((updater) => {
        setAllState((prev) => {
            const next =
                typeof updater === 'function' ? updater({ ...prev }) : updater;
            return next;
        });
    }, []);

    const state = { ...allState, changeData };

    return (
        <div className="marketing-v1-shell steps__container marketing-step2-production">
            <MarketingHeader />
            <CStepper indexStep={1} mobile={false} />
            <div className="step2__container">
                <div className="section" style={{ height: 'auto' }}>
                    <section className="selectGoalTop7__container">
                        <div className="selectGoalTop7__wrapper">
                            <MarketingOolaWheel allState={state} />
                            <div>
                                <SelectSevenSection
                                    updateIndexStep2={() => {}}
                                    forceUpdate={forceUpdate}
                                    AllState={state}
                                    changeData={changeData}
                                    hideNav={false}
                                    confirmGoals={() => {}}
                                    setShowSevenConfirm={() => {}}
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default MarketingStep2Preview;
